export default {
  label: {
    create: '作成',
    do_create: '作成する',
    edit: '編集',
    do_edit: '編集する',
    add: '追加',
    do_add: '追加する',
    update: '更新',
    do_update: '更新する',
    cancel: 'キャンセル',
    close: '閉じる',
    current: '現在',
    delete: '削除',
    save: '保存',
    do_save: '保存する',
  },
  page_titles: {
    cv_section_profile_edit: 'プロフィール 編集',
    cv_section_text_new: 'テキスト 新規作成',
    cv_section_text_edit: 'テキスト 編集',
    cv_section_date_new: '履歴 新規作成',
    cv_section_date_edit: '履歴 編集',
    cv_section_date_item_new: '履歴アイテム 新規作成',
    cv_section_date_item_edit: '履歴アイテム 編集',
    cv_section_skill_new: 'スキル 新規作成',
    cv_section_skill_edit: 'スキル 編集',
    cv_section_skill_item_new: 'スキルアイテム 新規作成',
    cv_section_skill_item_edit: 'スキルアイテム 編集',
    cv_section_link_new: '外部リンク 新規作成',
    cv_section_link_edit: '外部リンク 編集',
    cv_section_link_item_new: '外部リンクアイテム 新規作成',
    cv_section_link_item_edit: '外部リンクアイテム 編集',
    cv_section_gallery_new: '画像ギャラリー 新規作成',
    cv_section_gallery_edit: '画像ギャラリー 編集',
    cv_section_gallery_item_new: '画像ギャラリー 新規作成',
    cv_section_gallery_item_edit: '画像ギャラリー 編集',
    cover_letters_new: '志望動機書 新規作成',
    cover_letters_edit: '志望動機書 編集',
  },
  notification: {
    created: '作成しました',
    updated: '更新しました',
    deleted: '削除しました',
    copied: 'コピーを作成しました',
    check_input: '入力内容を確認してください',
    check_input_validation_error: 'エラー内容をご確認ください',
  },
};
